export const TokenConstants = {
    Session_Expired: "Your session has been expired, Please login again!"
}

export const ErrorMessageConstants = {
    Message: "Something went wrong ! Please try again after sometime."
}

export const TooltipConstants = {
   CommonTooltip : "tooltip updated successfully",
   ClaimByProjectTooltip: "Claim by projecy tooltip updated successfully",
   RDProjectRecordTooltip: "R&D project record tooltip updated successfully",
   BenefitSummERIS: "Benefit summary - ERIS tooltip updated successfully",
   BenefitSummRDEC: "Benefit summary - RDEC tooltip updated successfully"
}